<template>
  <section class="quote-refer-info">
    <div class="box">
      <h2>Client Info</h2>
      <div class="table mg-b-10">
        <div class="tr">
          <span>Effective Date</span>
          <span>{{ formData.pcy_cmnt_date }}</span>
        </div>
        <div class="tr">
          <span>Type of Building </span>
          <span>{{ getAllOptionName26('bldg_types', formData.bldg_typ) }}</span>
        </div>
        <div class="tr">
          <span>Gross Floor Area (Indoor & Outdoor)</span>
          <span>{{ formData.floor_area }}</span>
        </div>
        <div class="tr">
          <span>Coverage </span>
          <span>{{ formData.home_coverage_language}}</span>
        </div>
        <div
          v-if="formData.bsc_sum_insured_language"
          class="tr">
          <span>Sum Insured of Building Structure</span>
          <span>{{  formData.bsc_sum_insured_language }}</span>
        </div>
        <div
          v-if="formData.coverage_id==3"
          class="tr">
          <span>Do you need us to post a copy of the policy document to the Mortgagee? </span>
          <span>{{ getOptionName('yesNoOptions', formData.post_ind) }}</span>
        </div>
        <div
          v-if="formData.post_ind == 1"
          class="tr">
          <span>Name of Mortgagee</span>
          <span>{{formData.post_nm}}</span>
        </div>
        <div
          v-if="formData.post_ind == 1"
          class="tr">
          <span>Address of Mortgagee</span>
          <span>{{formData.post_addr}}</span>
        </div>
        <div class="tr">
          <span>Property Age </span>
          <span>{{ getAllOptionName26('prop_age', formData.prop_age) }}</span>
        </div>
        <div class="tr">
          <span>Occupancy</span>
          <span>{{ getAllOptionName26('prop_insured', formData.prop_insured) }}</span>
        </div>
        <div
          v-if="formData.has_roof!=-1"
          class="tr">
          <span>Does the flat have a roof/garden/balcony/workspace or on the lower floor (1st to 3rd floor)?</span>
          <span>{{ getAllOptionName26('has_roof', formData.has_roof) }}</span>
        </div>
        <div class="tr">
          <span>Is your Location of Risk same as Correspondence Address?</span>
          <span>{{ getOptionName('yesNoOptions', formData.is_same_as_corr_addr) }}</span>
        </div>
      </div>
      <h3>Location of Risk</h3>
      <div class="table">
        <div class="tr">
          <span>Room</span>
          <span>{{ isSameAddress? formData.addr_room :formData.insured_addr_room }}</span>
        </div>
        <div class="tr">
          <span>Floor</span>
          <span>{{ isSameAddress? formData.addr_floor :formData.insured_addr_floor }}</span>
        </div>
        <div class="tr">
          <span>Block</span>
          <span>{{ isSameAddress? formData.addr_block :formData.insured_addr_block }}</span>
        </div>
        <div class="tr">
          <span>Building / Estate</span>
          <span>{{ isSameAddress? formData.addr_building :formData.insured_addr_building }}</span>
        </div>
        <div class="tr">
          <span>Street</span>
          <span>{{ isSameAddress? formData.addr_street :formData.insured_addr_street }}</span>
        </div>
        <div class="tr">
          <span>District</span>
          <span>{{ getAreaName('district', isSameAddress? formData.addr_district :formData.insured_addr_district) }}</span>
        </div>
        <div class="tr">
          <span>Area</span>
          <span>{{ getAreaName('area', isSameAddress? formData.addr_area :formData.insured_addr_area) }}</span>
        </div>
        <div class="tr">
          <span>Country / Region</span>
          <span>{{ getAreaName('region', isSameAddress? formData.addr_region :formData.insured_addr_region) }}</span>
        </div>
      </div>
    </div>

    <div class="box">
      <h2>Policyholder Detail</h2>
      <div class="table">
        <template v-if="formData.cust_typ == 1">
          <div class="tr">
            <span>Title</span>
            <span>{{ getOptionName('titleOptions', formData.isrd_title) }}</span>
          </div>
          <div class="tr">
            <span>Last Name</span>
            <span>{{ formData.isrd_lst_nm }}</span>
          </div>
          <div class="tr">
            <span>First Name</span>
            <span>{{ formData.isrd_fst_nm }}</span>
          </div>
          <div class="tr">
            <span>Date of Birth</span>
            <span>{{ formData.isrd_dob_date }}</span>
          </div>
          <div class="tr">
            <span>HKID</span>
            <span>{{ formData.id_no }}</span>
          </div>
          <div class="tr">
            <span>Mobile Number</span>
            <span>{{ formData.mobile_no }}</span>
          </div>
          <div class="tr">
            <span>Email</span>
            <span>{{ formData.email }}</span>
          </div>
          <div class="tr">
            <span>Occupation</span>
            <span>{{ formData.occ}}</span>
          </div>
          <template v-if="isShowOwners">
            <div class="tr">
              <span>Are there joint owners?</span>
              <span
                v-copy="getOptionName('yesNoOptions',formData.joint_owner_ind)"
              >{{ getOptionName('yesNoOptions',formData.joint_owner_ind) }}</span>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="tr">
            <span>Company Name</span>
            <span>{{ formData.isrd_com_nm }}</span>
          </div>
          <div class="tr">
            <span>Business Registration Number</span>
            <span>{{ formData.id_no }}</span>
          </div>
          <!--          <div class="tr">-->
          <!--            <span>CI Number</span>-->
          <!--            <span>{{ formData.ci_no }}</span>-->
          <!--          </div>-->
          <div class="tr">
            <span>Company Phone No.</span>
            <span>{{ formData.phone_no }}</span>
          </div>
          <div class="tr">
            <span>Company Email</span>
            <span>{{ formData.email }}</span>
          </div>
          <div class="tr">
            <span>Nature of Business</span>
            <span>{{ getAllOptionName26('industry', formData.bsns_nature_id) }}</span>
          </div>
          <template v-if="isShowOwners">
            <div class="tr">
              <span>Are there joint owners?</span>
              <span
                v-copy="getOptionName('yesNoOptions',formData.joint_owner_ind)"
              >{{ getOptionName('yesNoOptions',formData.joint_owner_ind) }}</span>
            </div>
          </template>
          <span class="title">Contact Person</span>
          <div class="tr">
            <span>Name</span>
            <span>{{ formData.contact_nm }}</span>
          </div>
          <div class="tr">
            <span>Occupation</span>
            <span>{{ getAllOptionName24('occupation', formData.contact_occ_id) }}</span>
          </div>
          <div class="tr">
            <span>Phone No.</span>
            <span>{{ formData.contact_phone }}</span>
          </div>
          <div class="tr">
            <span>Email</span>
            <span>{{ formData.contact_email }}</span>
          </div>
        </template>
      </div>
    </div>
    <template  v-if="formData.joint_owner_ind==1">
      <div class="box">
        <h3>Joint Policyholder Details</h3>
        <div class="table">

          <div
            class="tr">
            <span>Joint Policyholder - Full Name</span>
            <span
              v-copy="formData.joint_owner_nm"
            >{{formData.joint_owner_nm}}</span>
          </div>
          <div
            class="tr">
            <span>Date of Birth</span>
            <span
              v-copy="formData.joint_owner_dob"
            >{{formData.joint_owner_dob}}</span>
          </div>
          <div
            class="tr">
            <span>Joint Policyholder - {{getOptionName('personalIdTypOptions',formData.joint_owner_id_type)}}</span>
            <span
              v-copy="formData.joint_owner_id_no"
            >{{formData.joint_owner_id_no}}</span>
          </div>
        </div>
      </div>
    </template>
    <div class="box">
      <h3>Correspondence Address	</h3>
      <div class="table">
        <div class="tr">
          <span>Room</span>
          <span>{{ formData.addr_room }}</span>
        </div>
        <div class="tr">
          <span>Floor</span>
          <span>{{ formData.addr_floor }}</span>
        </div>
        <div class="tr">
          <span>Block</span>
          <span>{{ formData.addr_block }}</span>
        </div>
        <div class="tr">
          <span>Building / Estate</span>
          <span>{{ formData.addr_building }}</span>
        </div>
        <div class="tr">
          <span>Street</span>
          <span>{{ formData.addr_street }}</span>
        </div>
        <div class="tr">
          <span>District</span>
          <span>{{ getAreaName('district', formData.addr_district) }}</span>
        </div>
        <div class="tr">
          <span>Area</span>
          <span>{{ getAreaName('area', formData.addr_area) }}</span>
        </div>
        <div class="tr">
          <span>Country / Region</span>
          <span>{{ getAreaName('region', formData.addr_region) }}</span>
        </div>
      </div>
    </div>

    <!-- <div class="box">
      <h2>Coverage</h2>
      <div class="table">
        <div class="tr">
          <span>Sum Insured</span>
          <span>{{ formData.sum_insured }} HKD</span>
        </div>
      </div>
    </div> -->

    <div class="box">
      <h3>Section 1 – Household Contents “All Risks”</h3>
      <div class="table">
        <div class="tr">
          <span>Mobile Phone 1 Model declaration</span>
          <span>{{ formData.phone_mdl_1 }}</span>
        </div>
        <div class="tr">
          <span>Mobile Phone 2 Model declaration</span>
          <span>{{ formData.phone_mdl_2 }}</span>
        </div>
      </div>
    </div>

    <!-- <div class="box">
      <h3>Owner's Liability</h3>
      <div class="table">
        <div class="tr">
          <span>Owner's Liability</span>
          <span>{{ getOptionName('yesNoOptions', formData.owner_liability_ind) }}</span>
        </div>
        <div class="tr">
          <span>Sum Insured of Owner's Liability</span>
          <span>{{ getAllOptionName26('owner_liability', formData.sum_owner_liability) }}</span>
        </div>
      </div>
    </div> -->

    <!-- todo -->
    <div class="box">
      <h2>Upload Document</h2>
      <div class="table">
        <div class="tr">
          <span  v-if="formData.cust_typ == 2">Business Registration Certificate</span>
          <span v-else>Policyholder HKID</span>
          <span
            class="file"
            @click="openFile(formData.id_type_pic.url)">{{ formData.id_type_pic? 'file': '' }}</span>
        </div>
        <div
          v-if="formData.cust_typ == 2"
          class="tr">
          <span>Business Registration Certification</span>
          <span
            class="file"
            @click="openFile(formData.cert_of_inc_pic.url)">{{ formData.cert_of_inc_pic? 'file': '' }}</span>
        </div>
        <div
          v-for="(item, index) in formData.other_file"
          :key="index"
          class="tr">
          <span>Additional Documents</span>
          <span
            class="file"
            @click="openFile(item.url)">{{ item.url? 'file': '' }}</span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'

export default {
  name: 'DecorationQuoteReferInfo',
  mixins: [MixinOptions],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isSameAddress() {
      return this.formData.is_same_as_corr_addr == 1
    },
    isShowOwners(){
      let {prop_insured} = this.formData||{}
      return prop_insured!=3
    },
  },
  methods: {
    openFile(url) {
      if(!url) return
      window.open(url, '_blank')
    },
  }
}
</script>
<style lang="scss" scoped>
.quote-refer-info {
  .box {
    margin-bottom: 15px;
  }
  .title {
    display: block;
    padding-bottom: 15px;
    font-size: 16px;
    font-weight: 400;
    color: #616266;
  }
  .file {
    color: $blue;
    cursor: pointer;
  }
}
</style>
